import React, { Component } from 'react';
import { Text, Flex, Button, TextField, Dropdown, Tooltip, IconButton, RadioButton } from 'monday-ui-react-core';
import { Close, Add } from "monday-ui-react-core/icons";
import { Heading } from "monday-ui-react-core/next";
import classes from "./create-filter.module.scss";
import { createFilter, getFilters, getFullFilter } from '../../services/backend-service';
import mondaySdk from "monday-sdk-js";
import { valueCreated } from '../../services/hooks';

class CreateFilter extends Component {  
  constructor(props) {
    super(props);
    this.state = {
      filterName: "",
      filterType: { label: "All rules must match", value: "AND" },
      allowedToUseApp: props.allowedToUseApp || false,
      loading: false,
      createOperation: true,
      isItemsDropdownsLoading: false,
      itemName: null,
      itemId: null,
      itemOptions: [],
      subjectFilters: [],
      bodyFilters: [],
      fromFilters: [],
      error: ""
    };
  }

  componentDidMount() {
    const monday = mondaySdk();

    monday.listen("context", (res) => {
      this.setState({
        allowedToUseApp: !(res.data.user.isGuest || res.data.user.isViewOnly)
      });
    });
  }

  createFilter() {
    if(!this.state.createOperation && !this.state.itemId) {
      this.setState({
        error: "Please select filter you want to modify"
      });
      return;
    }

    if(this.state.filterName.length < 4) {
      this.setState({
        error: "Filter name must be at least 4 characters long."
      });
      return;
    }

    if((this.state.subjectFilters.length === 0)
      && (this.state.bodyFilters.length === 0)
      && (this.state.fromFilters.length === 0)
    ) {
      this.setState({
        error: "Create at least 1 rule."
      });
      return;
    }

    this.setState({
      loading: true,
      error: ""
    });

    const filters = {
      itemId: this.state.createOperation ? null : this.state.itemId,
      name: this.state.filterName,
      filters: {
        filterType: this.state.filterType.value ? this.state.filterType.value : "AND",
        subjectFilters: this.state.subjectFilters,
        bodyFilters: this.state.bodyFilters,
        fromFilters: this.state.fromFilters
      }
    }

    const self = this;
    createFilter(filters).then((result) => {
      self.setState({
        loading: false
      });

      if(result.error) {
        this.setState({
          error: result.error
        });
        return;
      }

      valueCreated();
      if(result.backToUrl) {
        window.location.replace(result.backToUrl);
      } else {
        this.setState({
          error: "Your session has expired, please re-create your monday.com board automation"
        });
        return;
      }
    }).catch((error) => {
      self.setState({
        loading: false
      });

      if(error) {
        this.setState({
          error: error
        });
        return;
      }
    })
  }

  async fetchFilters() {
    this.setState({
      isItemsDropdownsLoading: true
    });

    const data = await getFilters();
    if(data?.code === 401) {
      this.setState({
        error: "Your session has expired, please re-create your monday.com board automation",
        isItemsDropdownsLoading: false
      });
      return;
    }

    let results = [];
    (data || []).forEach((filter) => {
      if(filter.value !== -1) {
        results.push({
          label: filter.title,
          value: filter.value
        });
      }
    });

    this.setState({
      itemOptions: results,
      isItemsDropdownsLoading: false
    });
  }

  async fillInFilterDetails(id) {
    this.setState({
      isItemsDropdownsLoading: true
    });

    const filter = await getFullFilter(id);
    if(filter?.code === 401) {
      this.setState({
        error: "Your session has expired, please re-create your monday.com board automation",
        isItemsDropdownsLoading: false
      });
      return;
    }

    const metadata = filter?.metadata || {};
    const filterTypeValue = metadata?.filterType || "AND";

    this.setState({
      itemId: id,
      filterName: filter?.title || "",
      filterType: {
        label: filterTypeValue === "OR" ? "At least 1 rule must match" : "All rules must match",
        value: filterTypeValue
      },
      subjectFilters: metadata?.subjectFilters || [],
      bodyFilters: metadata?.bodyFilters || [],
      fromFilters: metadata?.fromFilters || [],
      isItemsDropdownsLoading: false
    });
  }

  async clearSelections() {
    this.setState({
      filterName: "",
      filterType: { label: "All rules must match", value: "AND" },
      itemName: null,
      itemId: null,
      subjectFilters: [],
      bodyFilters: [],
      fromFilters: [],
      error: "",
      isItemsDropdownsLoading: false
    });
  }

  cancel() {
    const filters = {
      cancel: true
    }

    createFilter(filters).then((result) => {
      if(result.error) {
        this.setState({
          error: result.error
        });
        return;
      }

      if(result.backToUrl) {
        window.location.replace(result.backToUrl);
      } else {
        this.setState({
          error: "Your session has expired, please re-create your monday.com board automation"
        });
        return;
      }
    }).catch((error) => {
      if(error) {
        this.setState({
          error: error
        });
        return;
      }
    })
  }

  handleValueChange(value, type) {
    if(type === "filterName") {
      this.setState({
        filterName: value
      });
    } else if(type === "filterType") {
      this.setState({
        filterType: { label: value ? value.label : "", value: value.value ? value.value : "" }
      });
    }
  }
  
  changeSubjectFilters(filterType, index) {
    let newFilters = this.state[filterType].slice();

    if(index >= 0) {
      newFilters.splice(index, 1);
    } else {
      newFilters.push({"condition":"", "value":""})
    }

    this.setState({ 
      [filterType]: newFilters
    });
  }

  handleSubjectFiltersChange(filterType, value, index, isCondition) {
    let newFilters = this.state[filterType].slice();
    if(isCondition) {
      newFilters[index].condition = value;
    } else {
      newFilters[index].value = value;
    }

    this.setState({
      [filterType]: newFilters
    });
  }

  render() {
    return (
      <Flex align={Flex.align.CENTER} gap={Flex.gaps.LARGE} direction={Flex.directions.COLUMN} justify={Flex.justify.CENTER} className={classes.container}>
        <Flex align={Flex.align.CENTER} gap={Flex.gaps.SMALL} direction={Flex.directions.COLUMN}>
            <img className={classes.emptySetImg} alt="Create filtering rules" src="/monday/imap/v1/config/images/logo.png" />
            <Heading type={Heading.types.H2}>Create filtering rules</Heading>
            <Text type={Text.types.TEXT1}>Optinally, create e-mail filtering rules to restrict which inbound e-mails will be processed</Text>
            <Text type={Text.types.TEXT1} className={classes.errorMessage}>{this.state.error}</Text>
        </Flex>
        <Flex align={Flex.align.START} gap={Flex.gaps.SMALL} direction={Flex.directions.COLUMN} className={classes.fields}>
          <Text type={Text.types.TEXT1}>What operation do you want to perform?</Text>
          <Flex align={Flex.align.CENTER} gap={Flex.gaps.MEDIUM} direction={Flex.directions.ROW} className={classes.fields}>
            <RadioButton
              text="Create new"
              name="operation-group"
              checked={this.state.createOperation}
              onSelect={async () => {
                await this.clearSelections();
                this.setState({createOperation: true});
              }}
            />
            <RadioButton
              text="Update existing"
              name="operation-group"
              checked={!this.state.createOperation}
              onSelect={async () => {
                await this.clearSelections();
                this.setState({createOperation: false});
                this.fetchFilters();
              }}
            />
          </Flex>
          {(!this.state.createOperation)
          ? <Flex align={Flex.align.START} gap={Flex.gaps.SMALL} direction={Flex.directions.COLUMN} className={classes.fullWidth}>
            <Text type={Text.types.TEXT1}>Select the filter you want to modify</Text>
            <Dropdown
              className={classes.fullWidth}
              placeholder="Select a filter"
              isLoading={this.state.isItemsDropdownsLoading}
              value={{label: this.state.itemName, value: this.state.itemId}}
              onChange={(e) => {
                this.setState({
                  itemName: e ? e.label : null,
                  itemId: e ? e.value : null
                });

                if(e?.value) {
                  this.fillInFilterDetails(e.value);
                }
              }}
              options={this.state.itemOptions}
            />
          </Flex>
          : <div></div>}
          <Text type={Text.types.TEXT1}>Filter Name</Text>
          <TextField 
            size={TextField.sizes.MEDIUM} 
            required={true}
            value={this.state.filterName}
            onChange={(value) => { 
              this.handleValueChange(value, "filterName") 
            }}/>
          <Text type={Text.types.TEXT1}>Filter Type</Text>
          <Dropdown
              id={ "filterType" } 
              size={Dropdown.sizes.MEDIUM}
              className={classes.fullWidth}
              required={true}
              value={ this.state.filterType }
              onChange={(value) => { 
                this.handleValueChange(value, "filterType") 
              }}
              options={[
                {
                  label: 'All rules must match',
                  value: 'AND'
                },
                {
                  label: 'At least 1 rule must match',
                  value: 'OR'
                }
              ]}
            />
          <Flex align={Flex.align.CENTER} gap={Flex.gaps.SMALL} direction={Flex.directions.ROW}>
            <Text type={Text.types.TEXT1}>Subject</Text>
            <Tooltip content="Add subject rule" position={Tooltip.positions.BOTTOM} animationType={Tooltip.animationTypes.EXPAND} maxWidth>
              <IconButton
                icon={Add}
                kind="tertiary"
                size={IconButton.sizes.SMALL}
                onClick={() => {this.changeSubjectFilters("subjectFilters", -1)}}
              />
            </Tooltip>
          </Flex>

          {this.state.subjectFilters.map((row, index) => (
            <Flex align={Flex.align.START} gap={Flex.gaps.SMALL} direction={Flex.directions.ROW} className={classes.fullWidth}>
              <Dropdown
                id={ "subjectFilterCondition-" + index } 
                placeholder="Condition"
                size={Dropdown.sizes.MEDIUM}
                className={classes.fullWidth}
                required={true}
                value={ { label: row.condition, value: row.condition } }
                onChange={(e) => { 
                  this.handleSubjectFiltersChange("subjectFilters", e ? e.value : "", index, true) 
                }}
                options={[
                  {
                    label: 'contains',
                    value: 'contains'
                  },
                  {
                    label: 'doesn\'t contain',
                    value: 'doesn\'t contain'
                  }
                ]}
              />
              <TextField 
                id={ "subjectFilterValue-" + index } 
                size={TextField.sizes.MEDIUM} 
                required={true}
                placeholder='Filter'
                className={classes.fullWidth}
                value={row.value} 
                onChange={(value) => { 
                  this.handleSubjectFiltersChange("subjectFilters", value, index, false) 
                }}/>
              <Tooltip content="Remove" position={Tooltip.positions.BOTTOM} animationType={Tooltip.animationTypes.EXPAND} maxWidth>
                <IconButton
                  icon={Close}
                  kind="tertiary"
                  size={IconButton.sizes.SMALL}
                  onClick={() => {this.changeSubjectFilters("subjectFilters", index)}}
                />
              </Tooltip>
            </Flex>
          ))}

          <Flex align={Flex.align.CENTER} gap={Flex.gaps.SMALL} direction={Flex.directions.ROW}>
            <Text type={Text.types.TEXT1}>Body</Text>
            <Tooltip content="Add body rule" position={Tooltip.positions.BOTTOM} animationType={Tooltip.animationTypes.EXPAND} maxWidth>
              <IconButton
                icon={Add}
                kind="tertiary"
                size={IconButton.sizes.SMALL}
                onClick={() => {this.changeSubjectFilters("bodyFilters", -1)}}
              />
            </Tooltip>
          </Flex>

          {this.state.bodyFilters.map((row, index) => (
            <Flex align={Flex.align.START} gap={Flex.gaps.SMALL} direction={Flex.directions.ROW} className={classes.fullWidth}>
              <Dropdown
                id={ "bodyFilterCondition-" + index } 
                placeholder="Condition"
                size={Dropdown.sizes.MEDIUM}
                className={classes.fullWidth}
                required={true}
                value={ { label: row.condition, value: row.condition } }
                onChange={(e) => { 
                  this.handleSubjectFiltersChange("bodyFilters", e ? e.value : "", index, true) 
                }}
                options={[
                  {
                    label: 'contains',
                    value: 'contains'
                  },
                  {
                    label: 'doesn\'t contain',
                    value: 'doesn\'t contain'
                  }
                ]}
              />
              <TextField 
                id={ "bodyFilterValue-" + index } 
                size={TextField.sizes.MEDIUM} 
                required={true}
                placeholder='Filter'
                className={classes.fullWidth}
                value={row.value} 
                onChange={(value) => { 
                  this.handleSubjectFiltersChange("bodyFilters", value, index, false) 
                }}/>
              <Tooltip content="Remove" position={Tooltip.positions.BOTTOM} animationType={Tooltip.animationTypes.EXPAND} maxWidth>
                <IconButton
                  icon={Close}
                  kind="tertiary"
                  size={IconButton.sizes.SMALL}
                  onClick={() => {this.changeSubjectFilters("bodyFilters", index)}}
                />
              </Tooltip>
            </Flex>
          ))}

          <Flex align={Flex.align.CENTER} gap={Flex.gaps.SMALL} direction={Flex.directions.ROW}>
            <Text type={Text.types.TEXT1}>From</Text>
            <Tooltip content="Add From rule" position={Tooltip.positions.BOTTOM} animationType={Tooltip.animationTypes.EXPAND} maxWidth>
              <IconButton
                icon={Add}
                kind="tertiary"
                size={IconButton.sizes.SMALL}
                onClick={() => {this.changeSubjectFilters("fromFilters", -1)}}
              />
            </Tooltip>
          </Flex>

          {this.state.fromFilters.map((row, index) => (
            <Flex align={Flex.align.START} gap={Flex.gaps.SMALL} direction={Flex.directions.ROW} className={classes.fullWidth}>
              <Dropdown
                id={ "fromFiltersCondition-" + index } 
                placeholder="Condition"
                size={Dropdown.sizes.MEDIUM}
                className={classes.fullWidth}
                required={true}
                value={ { label: row.condition, value: row.condition } }
                onChange={(e) => { 
                  this.handleSubjectFiltersChange("fromFilters", e ? e.value : "", index, true) 
                }}
                options={[
                  {
                    label: 'contains',
                    value: 'contains'
                  },
                  {
                    label: 'doesn\'t contain',
                    value: 'doesn\'t contain'
                  }
                ]}
              />
              <TextField 
                id={ "fromFiltersValue-" + index } 
                size={TextField.sizes.MEDIUM} 
                required={true}
                placeholder='Filter'
                className={classes.fullWidth}
                value={row.value} 
                onChange={(value) => { 
                  this.handleSubjectFiltersChange("fromFilters", value, index, false) 
                }}/>
              <Tooltip content="Remove" position={Tooltip.positions.BOTTOM} animationType={Tooltip.animationTypes.EXPAND} maxWidth>
                <IconButton
                  icon={Close}
                  kind="tertiary"
                  size={IconButton.sizes.SMALL}
                  onClick={() => {this.changeSubjectFilters("fromFilters", index)}}
                />
              </Tooltip>
            </Flex>
          ))}
        </Flex>
        <Flex align={Flex.align.START} gap={Flex.gaps.SMALL} direction={Flex.directions.ROW} justify={Flex.justify.CENTER} className={classes.fullWidth}>
          <Button 
            size={Button.sizes.MEDIUM} 
            kind={Button.kinds.PRIMARY}
            loading={this.state.loading}
            onClick={() => {
              this.createFilter();
            }}
          >
            {this.state.createOperation ? "Create Filter" : "Update Filter"}
          </Button>
          <Button 
            size={Button.sizes.MEDIUM} 
            kind={Button.kinds.SECONDARY}
            disabled={this.state.loading}
            onClick={() => {
              this.cancel();
            }}
          >
            Cancel
          </Button>
        </Flex>
      </Flex>
    );
  }
}

export default CreateFilter;
